export default function convertToPtBrDate(value: string) {
  const splitDate1 = value.split("T");
  const splitDate2 = splitDate1[0].split("-");
  const newDate = `${splitDate2[2]}/${splitDate2[1]}/${splitDate2[0]}`;

  return newDate;
}
